import { DOCUMENT_RISK_LEVEL } from '@/constants/documentReviewAgent';

export function documentRiskLevelToReadableLabel(riskLevel) {
  switch (riskLevel) {
    case DOCUMENT_RISK_LEVEL.LOW:
      return 'Low Risk';
    case DOCUMENT_RISK_LEVEL.MEDIUM:
      return 'Medium Risk';
    case DOCUMENT_RISK_LEVEL.HIGH:
      return 'High Risk';
    case DOCUMENT_RISK_LEVEL.NOT_APPLICABLE:
      return 'Not Applicable';
    default:
      return '';
  }
}
